/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/core';
import { Modal } from 'antd';
import { useIntl } from 'react-intl';
import { ThemedStyleFn, useStyles } from '~src/hooks/useStyles';
import { Fragment } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

type HelpModalProps = {
  visible: boolean;
  onClose: () => void;
  headerId: string;
};

const StatusIcon = ({ icon, color }: { icon: any; color: string }) => (
  <FontAwesomeIcon icon={icon} style={{ color, marginRight: 6 }} />
);

const HelpEN = () => (
  <Fragment>
    <span className="help-head">Login help head? EN</span>
    <span className="help-text">
      <StatusIcon icon={['far', 'envelope']} color="orange" /> login help text
      EN
    </span>
  </Fragment>
);

const HelpDA = () => (
  <Fragment>
    <span className="help-head">Login help head? DA</span>
    <span className="help-text">
      <StatusIcon icon={['far', 'envelope']} color="orange" /> login help text
      DA
    </span>
  </Fragment>
);

const getHelpComponent = (locale: string) => {
  switch (locale) {
    case 'da':
      return <HelpDA />;
    default:
      return <HelpEN />;
  }
};

export const LoginHelpInfoModal = ({
  visible,
  onClose,
  headerId,
}: HelpModalProps) => {
  const intl = useIntl();
  const styles = useStyles(styleFn);

  return (
    <Modal
      visible={visible}
      title={intl.formatMessage({ id: headerId })}
      onCancel={onClose}
      footer={null}
      width={700}>
      <div css={styles.helpContent}>{getHelpComponent(intl.locale)}</div>
    </Modal>
  );
};

export const styleFn: ThemedStyleFn = (theme) => ({
  helpContent: {
    '.help-head': {
      display: 'block',
      fontSize: 18,
      fontWeight: 'bold',
      marginTop: 18,
      marginBottom: 8,
      color: theme.colors.darkGray ?? '#333',
    },
    '.help-sub-head': {
      display: 'block',
      fontWeight: 600,
      marginTop: 14,
      color: theme.colors.black ?? '#444',
    },
    '.help-text': {
      display: 'block',
      fontSize: 14,
      margin: '4px 0 8px',
      color: theme.colors.black ?? '#666',
    },
  },
});
